//variable
export const company = (state) => state?.reportReducer?.company;
export const from = (state) => state?.reportReducer?.from;
export const to = (state) => state?.reportReducer?.to;
export const editSelector = (state) => state?.reportReducer?.edit;
export const dataUser = (state) => state?.reportReducer?.user;

//
export const reportDataSelector = (state) => state?.reportReducer?.reportData;
export const totalWorkingSelector = (state) =>
  state?.reportReducer?.totalWorking;
export const totalBreakingSelector = (state) =>
  state?.reportReducer?.totalBreaking;
export const rangeSelector = (state) => state?.reportReducer?.range;
//

export const photosSelector = (state) => state?.reportReducer?.photos;
export const locationsSelector = (state) => state?.reportReducer?.location;
// DIALOG
export const openSelector = (state) => state?.reportReducer?.open;
export const dialogUserSelector = (state) => state?.reportReducer?.dialogUser;
export const dialogDateSelector = (state) => state?.reportReducer?.dialogDate;
export const dialogTimeSelector = (state) => state?.reportReducer?.dialogTime;
